import { coverItems } from "@/mocks/home";

function SectionHead({
  no,
  title,
  desc,
  id,
}: {
  no: string;
  title: string;
  desc: string;
  id: string;
}) {
  return (
    <div id={id} className="mb-8 flex scroll-mt-24 flex-col gap-3 md:mb-10 md:flex-row md:items-end md:justify-between">
      <div>
        <p className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-widest2 text-accent-700">
          <span className="font-heading text-base">{no}</span>
          <span className="h-px w-6 bg-accent-500" />
        </p>
        <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
          {title}
        </h2>
      </div>
      <p className="max-w-sm text-sm leading-relaxed text-foreground-500 md:text-right">{desc}</p>
    </div>
  );
}

export default function CoverSection() {
  return (
    <section className="border-t border-background-200/70 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHead
          no="01"
          id="covers"
          title="本期封面 · 看图先翻这里"
          desc="每天挑出一组最有看头的街拍状态做封面，标题即画面，画面即氛围。"
        />

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          {coverItems.map((c, i) => (
            <article
              key={c.id}
              className={`group cursor-pointer overflow-hidden rounded-lg bg-background-100 ${
                i === 0 ? "lg:col-span-2 lg:row-span-2" : ""
              }`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={c.img}
                  alt={`吃瓜图集${c.tag}封面：${c.title}`}
                  title={`吃瓜图集 · ${c.tag}`}
                  className={`w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04] ${
                    i === 0 ? "h-72 md:h-80 lg:h-[540px]" : "h-52 md:h-60 lg:h-[260px]"
                  }`}
                />
                <span className="absolute right-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] text-primary-700">
                  {c.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold leading-snug text-foreground-950 md:text-base">
                  {c.title}
                </h3>
                <p className="mt-2 flex items-center justify-between text-xs text-foreground-500">
                  <span>{c.place}</span>
                  <span className="inline-flex items-center gap-1 text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
                    查看 <i className="ri-arrow-right-up-line" />
                  </span>
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}